import React, { Component } from 'react'
import { MDBCol, MDBContainer, MDBRow, MDBFooter } from "mdbreact";

export default class Footter extends Component {
    render() {
        return (
            <div>
        <footer className="footer--pin">
        <MDBFooter color="primary-color-dark" className="font-small pt-4 mt-4">
          <MDBContainer fluid className="text-center text-md-center">
            <MDBRow>
              <MDBCol md="12">
                <h5 className="title"> luckyresortkpp Kamphaeng Phet</h5>
                <p>
                ลักกี้สอร์ท
                </p>
              
              </MDBCol>
            
            </MDBRow>
          </MDBContainer>
          <div className="footer-copyright text-center py-3">
            <MDBContainer fluid>
              &copy; {new Date().getFullYear()} Copyright: <a href="https://luckyresortkpp.com/"> luckyresortkpp </a>
            </MDBContainer>
          </div>
        </MDBFooter>
        </footer>
            </div>
        )
    }
}
